module.exports = __webpack_public_path__ + "img/hopways-02.d6f9ec72.webp";